module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 2-5cc1c088c9137dad8ec2e807f31af00d.jpg";